import React from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS } from '@constants';
import { useStore } from '@hooks';
import { Typography } from '@ui';
import { formatString } from '@utils';
import { Card, Col, Flex } from 'antd';
import { observer } from 'mobx-react';

const SingleRecommendation = observer(({ item }) => {
    const navigate = useNavigate();
    const store = useStore();
    const { hasPreLaunchedCampaign } = store.campaignsStore;
    const { isManualWithSyncInProgressOrFailed } = store.accountsStore;

    const isDisabled = hasPreLaunchedCampaign || isManualWithSyncInProgressOrFailed;

    return (
        <Col span={12}>
            <Card
                data-e2e={`home_recommendation-${formatString(item.title)}_card`}
                styles={{ body: { padding: '48px 24px' } }}
                style={{
                    border: `1px solid ${COLORS.$gray15Black}`,
                    opacity: isDisabled ? 0.5 : 1,
                    cursor: isDisabled ? 'not-allowed' : 'pointer'
                }}
                hoverable={!isDisabled}
                onClick={() => {
                    if (!isDisabled) {
                        navigate(item.redirect);
                    }
                }}
            >
                <Flex align='center' justify='center' gap={24}>
                    <Flex align='center' justify='center'>
                        {item.logo}
                    </Flex>
                    <Flex vertical gap={8}>
                        <Typography.Text type='badgeLarge'>{item.title}</Typography.Text>
                        <Typography.Text color={COLORS.$gray60Black} type='descriptor1'>
                            {item.description}
                        </Typography.Text>
                    </Flex>
                </Flex>
            </Card>
        </Col>
    );
});

export default SingleRecommendation;
